import React, { useCallback } from 'react';
import { useHistory } from 'react-router';
import { TYPE_LINK, TYPE_URL, useOfferLinkGetter } from 'cityads-v3/hooks/offers';
import { Offer, OfferStat } from 'cityads-v3/types/offers';
import { PromoOffer } from 'cityads-v3/types/promoOffer';
import { OffersListProps } from './OffersList';
import classes from './Offers.scss';

import Table from 'cityads-v3/components/Table/Table';

import { useOffersWithPromoStyles, useOfferTableCols } from './OffersListTable.hooks';

export type OfferWithPromoAndStats = Partial<Offer & OfferStat & {
  promo: PromoOffer,
  classes: Record<string, string>,
  _style: Record<string, string>,
}>

export type OffersListTableProps = Omit<OffersListProps, 'view'>
const OffersListTable: React.FC<OffersListTableProps> = function OffersListCards({
  offers,
  linkSource,
  reloadFavoriteTotalCount
}) {
  const history = useHistory()
  const data = useOffersWithPromoStyles(offers);
  const tableCols = useOfferTableCols(reloadFavoriteTotalCount, linkSource);
  const linkGetter = useOfferLinkGetter();
  const getOfferLink = useCallback((id: Offer['id']) => linkGetter(
    id,
    linkSource
  ), [linkGetter, linkSource])

  const handleRowClick = useCallback((row: Offer, evt: React.MouseEvent<HTMLTableRowElement>) => {
    if (evt.defaultPrevented) {
      return;
    }

    let [link, linkType] = getOfferLink(row.id);

    if (linkType === TYPE_LINK) {
      history.push(link);
    } else if (linkType === TYPE_URL && typeof link === 'string') {
      window.location.href = link;
    }
  }, [history])

  return (
    <div className={classes.offers__table}>
      <Table
        paper
        innerScrollX
        showRowHover
        cols={tableCols}
        rows={data}
        onRowClick={handleRowClick}
        size="small"
      />
    </div>
  )
}

export default OffersListTable
